import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-[0.5rem] border px-2.5 py-1 text-xs font-regular transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-brand-100 text-neutral-700 hover:bg-secondary/80",
        destructive:
          "border-transparent bg-red-200 text-red-700 hover:bg-red-300",
        green:
          "border-transparent bg-success-200 text-success-700 hover:bg-success-300",
        warning:
          "border-transparent bg-warning-200 text-warning-700 hover:bg-warning-300",
        blocked:
          "border-transparent bg-brand-100 text-neutral-700 hover:bg-brand-200",
        frozen:
          "border-transparent bg-neutral-200 text-neutral-700 hover:bg-neutral-300",
        outlineBordered:
          "border-neutral-500 bg-transparent text-neutral-900 rounded-full hover:border-neutral-600",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
